import { returnAction } from '../return-action.util';
import { ActionEnum } from '../../../enum/action.enum';
import { PageModel } from '../../../model/page.model';

export const copyPage = (page: PageModel) => returnAction<PageModel>(ActionEnum.COPY_PAGE, page);
